<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <form class="forms-sample">
                        <b-form-group label="Menu Name">
                            <b-form-input v-model="menu.menuName"
                                          type="text" 
                                          placeholder="Name">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Description">
                            <b-form-textarea v-model="menu.description"
                                             :rows="3"
                                             :max-rows="6"
                                             placeholder="Description">
                            </b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Active on">
                            <b-form-checkbox-group v-model="openingDays" 
                                                   :options="weekdays">
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label="From Time">
                            <vue-timepicker v-model="fromTime"
                                            :minute-interval="5">
                            </vue-timepicker>
                        </b-form-group>
                        <b-form-group label="To Time">
                            <vue-timepicker v-model="toTime"
                                            :minute-interval="5">
                            </vue-timepicker>
                        </b-form-group>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions, mapState, mapGetters } from'vuex'
import VueTimepicker from 'vue2-timepicker'
import MenuBasicInfoBase from '../Bases/MenuBasicInfoBase'
import TimeFormatter from '../../../../src/assets/js/TimeFormatter'
export default{
    name: 'menuaddbasicinfo',
    extends : MenuBasicInfoBase,
    inject: ['eventBus'],
    props : {
        menu : { type : Object }
    },
    components: {
        VueTimepicker
    },
    data () {
        return {
            fromTime : {
                HH: "10",
                mm: "00",
                ss: "00"
            },
            toTime : {
                HH: "12",
                mm: "00",
                ss: "00"
            },
            openingDays: [0, 1, 2, 3, 4, 5, 6],
            weekdays : [
                {text: 'Mon', value: 1},
                {text: 'Tue', value: 2},
                {text: 'Wed', value: 3},
                {text: 'Thu', value: 4},
                {text: 'Fri', value: 5},
                {text: 'Sat', value: 6},
                {text: 'Sun', value: 0}
            ]
        }
    },
    methods: {
        processToCheckWeekDays() {
            if(this.openingDays.includes(1)) {
                this.menu.monday = true;
            } else {
                this.menu.monday = false;
            }
            if(this.openingDays.includes(2)) {
                this.menu.tuesday = true;  
            } else {
                this.menu.tuesday = false;
            }
            if(this.openingDays.includes(3)) {
                this.menu.wednesday = true;
            } else {
                this.menu.wednesday = false;
            }
            if(this.openingDays.includes(4)) {
                this.menu.thursday = true;
            } else {
                this.menu.thursday = false;
            }
            if(this.openingDays.includes(5)) {
                this.menu.friday = true;
            } else {
                this.menu.friday = false;
            }
            if(this.openingDays.includes(6)) {
                this.menu.saturday = true;
            } else {
                this.menu.saturday = false;
            }
            if(this.openingDays.includes(0)) {
                this.menu.sunday = true;
            } else {
                this.menu.sunday = false;
            }
        },
        handleOnNextEvent() {
            this.processToCheckWeekDays(); 
            this.menu.fromTime = TimeFormatter.timeToString(this.fromTime);
            this.menu.toTime = TimeFormatter.timeToString(this.toTime);
        },
        handleOnBackEvent() {

        }
    },
    created() {
    }
}
</script>